export enum CampaignFormComponentType {
  New = 0,
  Edit = 1,
  NewDraft = 2,
  EditDraft = 3,
}
